var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-left" }, [
    _c("div", { staticClass: "sidebar-body scroll-pane" }, [
      _c(
        "div",
        { staticClass: "side-nav" },
        [
          _c(
            "v-collapse",
            { attrs: { accordion: "" } },
            [
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Офферы\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/advertisers" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Рекламодатели\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/sources" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Источники\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/data" },
                      slot: "item-title"
                    },
                    [_vm._v("\n           Данные\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/exchange-rates" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Курсы валют\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/offers-report" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Отчет по офферам\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/users-report" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Отчет по медиабайерам\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/sources-report" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Отчет по источникам\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-collapse-item",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/date-report" },
                      slot: "item-title"
                    },
                    [_vm._v("\n            Отчет по времени\n          ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0efe7828", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efe7828","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/layouts/partials/TheSiteSidebar.vue
// module id = 629
// module chunks = 0